import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=3807252f&scoped=true"
import script from "./manager.vue?vue&type=script&lang=js"
export * from "./manager.vue?vue&type=script&lang=js"
import style0 from "./manager.vue?vue&type=style&index=0&id=3807252f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807252f",
  null
  
)

export default component.exports